// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  color: var(--color-card-text);
  border: none;
}

.cardTitle {
  font-weight: 600;
  margin-top: 1%;
  margin-bottom: 3%;
  font-size: large;
}

.order {
  padding-bottom: 15px;
  border-bottom: 1px solid var(--color-secondary);
}

.value {
  font-weight: 600;
}

.title {
  font-weight: 600;
  margin-top: 1%;
  font-size: 18px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--color-primary);
}

.name {
  font-weight: 600;
}

.card {
  width: 100%;
  padding: 15px 15px 0px 15px;
  margin-top: 10px;
}
.card .cardTitle {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
}

.table-header {
  border-bottom: 2px solid var(--color-primary);
  font-style: normal;
  font-size: 14px;
}

.table thead th {
  font-weight: 400;
}

.header-title {
  color: var(--color-interaction-text);
}

.table-content {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

.error {
  margin: 20px 0px 0px 0px;
}

.next-btn:focus-within {
  outline: black solid 2px;
  outline-offset: 0px;
}

.checklistBorder {
  display: block;
  padding-bottom: 10px;
  width: 95%;
  border-bottom: 2px solid var(--color-primary);
}

.checkboxAlignment {
  font-style: normal;
  font-weight: 600;
  padding-left: 15px;
}

.headerFont {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
}

.un-image {
  max-width: 100%;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/mobile/confirm-return/confirm-return.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AACA;EACE,oBAAA;EACA,+CAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AAAA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,6CAAA;AAGF;;AAAA;EACE,gBAAA;AAGF;;AAAA;EACE,WAAA;EACA,2BAAA;EACA,gBAAA;AAGF;AADE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AAGJ;;AACA;EACE,6CAAA;EACA,kBAAA;EACA,eAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,oCAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAEF;;AACA;EACE,wBAAA;AAEF;;AACA;EACE,wBAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;EACA,oBAAA;EACA,UAAA;EACA,6CAAA;AAEF;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AAGF;;AADA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AAIF;;AADA;EACE,eAAA;EACA,YAAA;AAIF","sourcesContent":[".card {\n  padding: 16px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  color: var(--color-card-text);\n  border: none;\n}\n\n.cardTitle {\n  font-weight: 600;\n  margin-top: 1%;\n  margin-bottom: 3%;\n  font-size: large;\n}\n.order {\n  padding-bottom: 15px;\n  border-bottom: 1px solid var(--color-secondary);\n}\n\n.value {\n  font-weight: 600;\n}\n.title {\n  font-weight: 600;\n  margin-top: 1%;\n  font-size: 18px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid var(--color-primary);\n}\n\n.name {\n  font-weight: 600;\n}\n\n.card {\n  width: 100%;\n  padding: 15px 15px 0px 15px;\n  margin-top: 10px;\n\n  .cardTitle {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 18px;\n  }\n}\n\n.table-header {\n  border-bottom: 2px solid var(--color-primary);\n  font-style: normal;\n  font-size: 14px;\n}\n\n.table thead th {\n  font-weight: 400;\n}\n\n.header-title {\n  color: var(--color-interaction-text);\n}\n\n.table-content {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n}\n\n.error {\n  margin: 20px 0px 0px 0px;\n}\n\n.next-btn:focus-within {\n  outline: black solid 2px;\n  outline-offset: 0px;\n}\n\n.checklistBorder {\n  display: block;\n  padding-bottom: 10px;\n  width: 95%;\n  border-bottom: 2px solid var(--color-primary);\n}\n.checkboxAlignment {\n  font-style: normal;\n  font-weight: 600;\n  padding-left: 15px;\n}\n.headerFont {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.un-image {\n  max-width: 100%;\n  height: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
